/* istanbul ignore file */
export default {
  content: {
    type: 'string',
    required: true,
    maxSize: 65000,
  },
};
